import React from 'react'
import {IconButton} from '@chakra-ui/react3'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {PauseIcon, PlayIcon} from '../../icons'

const VideoControl = ({isPlaying = false, onToggle, ...props}) => {
    const {formatMessage} = useIntl()

    return (
        <IconButton
            aria-label={
                isPlaying
                    ? formatMessage({
                          defaultMessage: 'Pause video',
                          id: 'leap.component.cms.video-control.button.pause-video'
                      })
                    : formatMessage({
                          defaultMessage: 'Play video',
                          id: 'leap.component.cms.video-control.button.play-video'
                      })
            }
            onClick={onToggle}
            variant="secondaryGhost"
            size="lg"
            {...props}
        >
            {isPlaying ? <PauseIcon /> : <PlayIcon />}
        </IconButton>
    )
}

VideoControl.propTypes = {
    isPlaying: PropTypes.bool,
    onToggle: PropTypes.func.isRequired
}

export default VideoControl
